(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-variant-input]').forEach(function(input) {
  input.addEventListener('change', function() {
    var label = document.querySelector('label[for="' + this.id + '"]');
    var metafield = label.dataset.metafield;
    var el = document.querySelector('.variant_shipping__timeline');
    var svg = document.querySelector('.variant_shipping__block svg');

    el.textContent = metafield.trim() ? metafield : '';
    if (svg) svg.style.display = metafield.includes('24 hrs') ? 'inline' : 'none';
  });
});

  } catch(e) { console.error(e); }
})();
})();
